import { SxProps } from "@mui/material";

export const gridContainer: SxProps = {
  margin: '0px',
};

export const infoGridItem: SxProps = {
  padding: '.5em 0em !important',
};
